<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-skeleton :row="20" :loading="loading">
      <div v-for="(item,index) in data" :key="index" class="papaerRect">
        <div class="title"><van-tag v-if="item.groupName" style="margin-right:0.5em" :color="GetColorMainBack()" type="primary">{{ item.groupName }}</van-tag>{{ item.title }}</div>
        <div class="papaer">
          <img v-if="item.isHave" :src="item.urlHave?item.urlHave:'/img/userpaperdefault.jpg'">
          <img v-if="!item.isHave" :src="item.urlUnHave?item.urlUnHave:'/img/userpaperdefault.jpg'">
        </div>
        <div class="aboutStr">{{ item.isHave?item.aboutUnget:item.aboutGet }}</div>
      </div>
      <div v-if="data.length<=0" class="emptyRect">暂无海报</div>
    </van-skeleton>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Skeleton, Image, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate, UrlBase64 } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetServiceUrlBase } from '@/utils/request'
import { getToken } from '@/utils/auth'

export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Image.name]: Image,
    [Tag.name]: Tag,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '我的海报',
      backurl: '/my/index',
      loading: true,
      data: []
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.loading = true
      request({
        url: '/Activity/getUserPaperList',
        method: 'post'
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        response.data.forEach(el => {
          if (el.urlHave) {
            if (!el.urlHave.toLowerCase().startsWith('http')) {
              el.urlHave = GetServiceUrlBase() + '/userAPI/activity/getUserSharePaper'
            }
            if (el.urlHave.indexOf('?') >= 0) {
              el.urlHave += '&token=' + UrlBase64(getToken()) + '&key=' + el.key
            } else {
              el.urlHave += '?token=' + UrlBase64(getToken()) + '&key=' + el.key
            }
          }
          if (el.urlUnHave) {
            if (!el.urlUnHave.toLowerCase().startsWith('http')) {
              el.urlUnHave = GetServiceUrlBase() + '/userAPI/activity/getUserSharePaper'
            }
            if (el.urlUnHave.indexOf('?') >= 0) {
              el.urlUnHave += '&token=' + UrlBase64(getToken()) + '&key=' + el.key
            } else {
              el.urlUnHave += '?token=' + UrlBase64(getToken()) + '&key=' + el.key
            }
          }
        })
        this.data = response.data
      })
    }
  }
}
</script>

<style scoped>
.papaerRect{
  margin-bottom: 1em;
  padding:1em;
  background-color: #fff;

}
.papaerRect .title{
  font-size: 0.9em;
  font-weight: 700;
  padding-bottom: 1em;
}
.papaerRect .aboutStr{
  font-size: 0.8em;
  padding: 0.5em 0;
  color: #999;
}
.papaerRect .papaer{
  width: 100%;
  border-radius: 0.4em;
  overflow: hidden;
}
.papaerRect .papaer img{
  width: 100%;
  border-radius: 0.4em;
  overflow: hidden;
}
.emptyRect{
  text-align: center;
  color: #999;
  font-size: 0.9em;
  margin-top: 40vh;
}
</style>
